




import { defineComponent, PropType } from "@vue/composition-api";
import { IMoreMenuItem } from "@/views/PageMore/config";

export default defineComponent({
  name: "MoreMenuItemSeparator",
  props: {
    item: { type: Object as PropType<IMoreMenuItem>, required: true },
  },
});
